import { ClientService } from "../../services/clientService";
import React, { useCallback, useState } from "react";

import moment from "moment";
import Loader from "../../control-components/loader/loader";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import FilterModel from "./filter-model";

const DATA_ITEM_KEY = "id";
const SELECTED_FIELD = "selected";

const ClientSearch = () => {
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [sort,] = useState([]);
  const [clients, setClients] = useState([]);
  const [total, setTotal] = useState(0);
  const [finalValue, setFinalValue] = useState();
  const [selectedMasterClinicId, setSelectedMasterClinicId] = useState();
  const [skip, setSkip] = useState(0)

  const fetchFromParent = (message, metaData) => {
    setClients(message);
    setTotal(metaData.totalCount);
    setPageSize(metaData.pageSize);
    setPage(0)
  };

  function pageChange(event) {
    let skip = event.page.skip;
    let take = event.page.take;
    let newValue = skip / take;
    let finalValue = newValue + 1;
    setFinalValue(finalValue)
    setSkip(skip);
    setPage(finalValue);
    setPageSize(take);
  }

  const impersonateClient = (clientId, masterClinicId) => {
    setLoading(true);
    ClientService.impersonateClient(clientId, masterClinicId)
      .then((result) => {
        setLoading(false);
        const url = result.resultData?.redirectUrl;
        window.open(url, "_blank");
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleSelectedMasterClinicIdChange = useCallback((clientId) => {
    setSelectedMasterClinicId(clientId);
  }, []);

  const handleClearGrid = useCallback(() => {
    setClients([])
    setTotal(0);
    setPage(0);
    setSkip(0);
    setFinalValue(1);
  }, [])

  return (
    <>

      <h4 className="address-title text-grey">
        <span className="f-24">Clients</span>
      </h4>
      <div className="row">
        <FilterModel
          page={page}
          pageSize={pageSize}
          finalValue={finalValue}
          fetchFromParent={fetchFromParent}
          setLoading={setLoading}
          onMasterClinicIdChange={handleSelectedMasterClinicIdChange}
          onClear={handleClearGrid}
        />
      </div>
      <div className="grid-table filter-grid">
        <div className="mt-3">
          <div className="inner-section-edit position-relative text-center">
            <div className="grid-table filter-grid ">
              <div className="mt-3">
                {loading ? <Loader />
                  :
                  <Grid
                    data={clients}
                    skip={skip}
                    take={pageSize}
                    onPageChange={pageChange}
                    total={total}
                    pageable={{
                      pageSizes: [10, 25, 50, 100, 250, 500],
                    }}
                    selectedField={SELECTED_FIELD}
                    dataItemKey={DATA_ITEM_KEY}
                    sort={sort}
                    sortable={true}
                    scrollable="none"
                  >
                    <GridColumn
                      className="cursor-default"
                      field="id"
                      title="Id"
                      width="100"
                      maxWidth="100px"
                      minWidth="150px"
                    />
                    <GridColumn
                      className="cursor-default"
                      field="fName"
                      title="Full Name"
                      width="200"
                      maxWidth="100px"
                      minWidth="150px"
                    />
                    <GridColumn
                      className="cursor-default"
                      field="lName"
                      title="Last Name"
                      width="200"
                      maxWidth="100px"
                      minWidth="150px"
                    />
                    <GridColumn
                      className="cursor-default"
                      field="username"
                      title="Username"
                      width="200"
                      maxWidth="100px"
                      minWidth="150px"
                    />
                    <GridColumn
                      className="cursor-default"
                      field="email"
                      title="Email"
                      width="300"
                      maxWidth="100px"
                      minWidth="150px"
                    />
                    <GridColumn
                      className="cursor-default"
                      field="dob"
                      title="DOB"
                      width="300"
                      maxWidth="100px"
                      minWidth="150px"
                      cells={{
                        data: (props) => {
                          const field = moment(props.dataItem.dob).format("MM/DD/YYYY");
                          return <td className="cursor-default">{field}</td>;
                        }
                      }}
                    />
                    <GridColumn
                      className="cursor-default"
                      width="300"
                      maxWidth="100px"
                      minWidth="150px"
                      field="ssn"
                      title="SSN"
                      cells={{
                        data: (props) => {
                          const field = props.dataItem.ssn;
                          const lastFour = String(field).slice(-4);
                          return (
                            <td className="cursor-default">
                              {field ? "***-**-" + lastFour : ""}
                            </td>
                          );
                        }
                      }}
                    />
                    <GridColumn
                      title="Active?"
                      field="isActive"
                      className="cursor-default"
                      width="100px"
                      cells={{
                        data: (props) => {
                          return <td className="cursor-default">{props.dataItem.isActive === "True" ? "Yes" : "No"}</td>;
                        }
                      }}
                    />
                    <GridColumn
                      className="cursor-default"
                      title="Impersonate"
                      width="120"
                      cells={{
                        data: (props) => {
                          const field = props.dataItem;
                          return (
                            <td>
                              <i
                                className="fa-solid fa-shuffle"
                                style={{ fontSize: 20, cursor: "pointer" }}
                                onClick={() => impersonateClient(field.id, selectedMasterClinicId)}
                              ></i>
                            </td>
                          );
                        }
                      }}
                    />
                  </Grid>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClientSearch;
